/// <amd-module name="CodeCoverage/CodeCoverageTab/Services/CodeCoverageDataService" />
import { ICodeCoverageTimelineSummaryData } from "CodeCoverage/Common/Interfaces/ICodeCoverageTimelineSummaryData";
import * as Common from "CodeCoverage/Common/Common";
import { ICodeCoverageDataService } from "CodeCoverage/Common/Interfaces/ICodeCoverageDataService";
import { RunViewArtifact } from "CodeCoverage/Common/RunViewArtifact";
import { CodeCoverageSource } from "CodeCoverage/Common/Sources/CodeCoverageSource";
import { Services, VssService } from "VSS/Platform/Context";

export class CodeCoverageDataService extends VssService implements ICodeCoverageDataService {
    public getCodeCoverageData(buildId: number, projectId: string): Promise<ICodeCoverageTimelineSummaryData[] | undefined> {
        const runViewArtifact = new RunViewArtifact(buildId, projectId, 2);
        const codeCoverageSource: CodeCoverageSource = CodeCoverageSource.getInstance({ pageContext: this.pageContext });
        return Common.GetCodeCoverageTimelineSummaryData(runViewArtifact, codeCoverageSource);
    }
}

Services.add("CC.CodeCoverageDataService", { serviceFactory: CodeCoverageDataService });
